<template>
  <div class="i-table">
    <!-- 标准产品 -->
    <div v-if="standardTotal > 0 || (standardTotal === 0 && commonTotal === 0 && (defaultstandardProductNum > 0 || defaultcommonProductNum > 0))" class="t-td" style="display: flex;">
      <div class="td1">
        <div><i class="el-icon-caret-top"></i></div>
        <div class="td1-name">
          <span>{{ $t("main.standardProductAbbr") }}</span>
        </div>
        <div><i class="el-icon-caret-bottom"></i></div>
      </div>
      <div class="td-r" v-if="standardTotal > 0">
        <div class="td-td" v-for="(item, index) in standardProductList" :key="item.id">
          <div :class="
                  ExpendIndex.includes(item.id) ? 'fac td-i hover' : 'fac td-i'
                ">
            <div class="td2" @click="handleExpendTable(item.id)">
              <i
                :class="
                  ExpendIndex.includes(item.id) ? 'el-icon-caret-bottom' : 'el-icon-caret-right'
                "
                style="color: #635796;"
              ></i>
            </div>
            <div
              class="td-n"
              v-for="v in columns"
              :style="
                  'product_model' === v.varname ? 'min-width:180px;' :
                  ('stock' === v.varname || 'price' === v.varname ? 'min-width:70px;' :columnsWidth)
                "
              :key="v.id"
              :title="item[v.varname]"
            >
              <span v-if="'price' === v.varname">{{ $t('main.monetaryUnit') }}</span>
              <span class="underline" @click="handleExpendTable(item.id)"
                    v-html="highlightKeywords(item[v.varname])"
                    :style="
                  'product_model' === v.varname ? 'text-decoration: underline;color: #5f5395;' : ''
                "></span>
            </div>
            <div class="th-n td14">
              <el-checkbox
                  class="addCompareForGoogle"
                v-model="item.checked"
                @change="(e) => {handleCheckboxChange(e, item, index, 'standardProductList')}"></el-checkbox>
            </div>
            <div class="td15">
              <div class="td13">
                <el-input-number
                  v-model="item.num"
                  controls-position="right"
                  @change="(e) => handleChange(e, item, index, 'standardProductList')"
                  :min="1"
                  style="width: 88px;"
                ></el-input-number>
              </div>
              <div class="td14 proBtn">
                <a @click="addInquiryToCard(item)" :title="$t('main.addInquiry')">
                  <img :alt="$t('main.addInquiry')" src="/static/product/tools/iq-m.png" class="mainBtn addInquiryForGoogle" />
                </a>
                <a v-if="item.stock > 0" @click="addGoodToCard(item)" :title="$t('main.addShopCar')">
                  <img :alt="$t('main.addShopCar')" src="/static/product/tools/gw-m.png" class="mainBtn addShopCarForGoogle mainBtnAct" />
                </a>
                <a v-else :title="$t('main.addShopCar')">
                  <img :alt="$t('main.addShopCar')" src="/static/product/tools/gw-m-dischoose.png" class="mainBtn addShopCarForGoogle" />
                </a>
              </div>
            </div>
          </div>
          <product-detail
            ref="expend"
            v-if="ExpendIndex.includes(item.id)"
            :productInfo="item"
            :columns="columns"
            :infoColumns="infoColumns"
            :name="name"
          >
          </product-detail>
        </div>
      </div>
      <div class="td-none" v-else>
        {{ $t("main.noData") }}
      </div>
    </div>
    <div v-if="standardTotal > 0" class="p-pages facab">
      <div></div>
      <div class="fac">
        <div>{{ $t("main.standardProduct") }}</div>
        <el-pagination
          :current-page="page"
          :page-size="limit"
          @current-change="handleCurrentChange" layout="pager" :total="standardTotal"></el-pagination>
      </div>
    </div>
    <div v-if="commonTotal" class="t-td" style="display: flex;">
      <div class="td1">
        <div><i class="el-icon-caret-top"></i></div>
        <div class="td1-name">
          <span>{{ $t("main.frequentlyUsedProductAbbr") }}</span>
        </div>
        <div><i class="el-icon-caret-bottom"></i></div>
      </div>
      <div class="td-r" v-if="commonTotal">
        <div class="td-td" v-for="(item, index) in commonProductList" :key="item.id">
          <div :class="
                  ExpendIndex.includes(item.id) ? 'fac td-i hover' : 'fac td-i'
                ">
            <div class="td2" @click="handleExpendTable(item.id)">
              <i
                :class="
                  ExpendIndex.includes(item.id) ? 'el-icon-caret-bottom' : 'el-icon-caret-right'
                "
                style="color: #635796;"
              ></i>
            </div>

            <div
              v-for="v in columns"
              :key="v.id"
              :style="
                  'product_model' === v.varname ? 'min-width:180px;' :
                  ('stock' === v.varname || 'price' === v.varname ? 'min-width:70px;' :columnsWidth)
                "
              class="td-n"
              :title="item[v.varname]"
            >
              <span v-if="'price' === v.varname">{{ $t('main.monetaryUnit') }}</span>
              <span class="underline" @click="handleExpendTable(item.id)"
                    :style="
                  'product_model' === v.varname ? 'text-decoration: underline;color: #5f5395;' : ''
                "
                    v-html="highlightKeywords(item[v.varname])"></span>
              <!-- {{ item[v.varname] }} -->
            </div>
            <div class="th-n td14">
              <el-checkbox
                  class="addCompareForGoogle"
                v-model="item.checked"
                @change="(e) => {handleCheckboxChange(e, item, index, 'standardProductList')}"></el-checkbox>
            </div>
            <div class="td15">
              <div class="td13">
                <el-input-number
                  v-model="item.num"
                  controls-position="right"
                  @change="(e) => handleChange(e, item, index, 'commonProductList')"
                  :min="1"
                  style="width: 88px;"
                ></el-input-number>
              </div>
              <div class="td14 proBtn">
                <a @click="addInquiryToCard(item)" :title="$t('main.addInquiry')">
                  <img :alt="$t('main.addInquiry')" src="/static/product/tools/iq-m.png" class="mainBtn addInquiryForGoogle" />
                </a>
                <a v-if="item.stock > 0" @click="addGoodToCard(item)" :title="$t('main.addShopCar')">
                  <img :alt="$t('main.addShopCar')" src="/static/product/tools/gw-m.png" class="mainBtn addShopCarForGoogle mainBtnAct" />
                </a>
                <a v-else :title="$t('main.addShopCar')">
                  <img :alt="$t('main.addShopCar')" src="/static/product/tools/gw-m-dischoose.png" class="mainBtn addShopCarForGoogle" />
                </a>
              </div>
            </div>
          </div>
          <product-detail
            ref="expend"
            v-if="ExpendIndex.includes(item.id)"
            :productInfo="item"
            :columns="columns"
            :infoColumns="infoColumns"
            :name="name"
          />
        </div>
      </div>
      <div class="td-none" v-else>
        {{ $t("main.noData") }}
      </div>
    </div>
    <div v-if="commonTotal" class="p-pages facab">
      <div></div>
      <div class="fac">
        <div>{{ $t("main.frequentlyUsedProduct") }} </div>
        <el-pagination
            layout="pager"
            :current-page="page2"
            :page-size="limit"
            @current-change="handleCurrentChange2"
            :total="commonTotal">
        </el-pagination>
      </div>
    </div>
    <div v-if="customColumns.length >0" class="i-info sticky" style="margin-bottom: 2rem;" id="section3">
      <div class="facab">
        <div class="ii-title">{{ $t("main.productBuild") }}</div>
        <el-button class="tjBtn" @click="handleSubmitCustom">{{ $t("main.commit") }}</el-button>
      </div>
      <div class="dz-box fac">
        <div class="dz-l">
          <div v-for="(item, index) in customColumns" :key="item.varname" :style="customStyles(index)">
            <span style="margin-right: 1rem;">
                <span class="required">*</span>
              {{ item.title }}
            </span>
            <el-input
              :placeholder="$t('main.pleaseEnter')"
              v-model="customForm[item.varname]"
              :id="'customInput_' + index"
              minlength="1"
              clearable
              style="width: 12.5rem !important;"
            ></el-input>
          </div>
        </div>
        <div class="dz-r">
          <div class="facab" style="margin-bottom: 0.5rem;">
            <div>{{ $t("main.remark") }}</div>
            <el-input-number
              v-model="customForm.num"
              controls-position="right"
              :min="1"
            ></el-input-number>
          </div>
          <el-input
            type="textarea"
            :rows="12"
            :placeholder="$t('main.pleaseEnter')"
            v-model="customForm.remark"
          >
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductDetail from "./productDetail.vue";
import { getProductInfo, getProductTpyeList, getProductTpyeListFields, reportApi, addSelfProduction } from "@/api";
import { addShopcar, addToCompare, deleteCompare } from "@/api/shopcar";
import { addInquiry } from "@/api/inquiry";
import Cookies from "js-cookie";

export default {
  components: { ProductDetail },
  props: ["tags", "searchParam", "productImage", "id"],
  data() {
    return {
      productTypeInfo: [],
      infoColumns: [],
      name: "",
      page2: 1,
      page: 1,
      limit: 10,
      filterArr: ["price", "stock"],
      isCosp: false,
      ExpendIndex: [],
      steps: [],
      typeList: [],
      columns: [],
      expends: [],//后面的
      liststart: [],//前面两个
      commonProductList: [],
      standardProductList: [],
      defaultstandardProductNum:-1,
      defaultcommonProductNum:-1,
      standardTotal: 0,
      commonTotal: 0,
      input: "",
      textarea: "",
      num: "",
      keyword: "",
      reportInfo: {
        email: "",
        content: ""
      },
      customColumns: [],
      remark: "",
      customForm: {
        remark: "",
        num: 1
      },
      rules: {}
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
      this.page = 1;
      this.page2 = 1;
      this.getProductList(this.tags, this.searchParam);
    },
    "$store.state.tabs": function() {
      this.init();
      this.page = 1;
      this.page2 = 1;
      this.getProductList(this.tags, this.searchParam);
    },
    tags: function(newV) {
      this.page = 1;
      this.page2 = 1;
      this.getProductList(newV, this.searchParam);
    },
    commonTotal(newV) {
      this.$emit("changeNum", {
        commonTotal: newV,
        standardTotal: this.standardTotal
      });
    },
    standardTotal(newV) {
      this.$emit("changeNum", {
        standardTotal: newV,
        commonTotal: this.commonTotal
      });
    }
  },
  computed: {
    columnsWidth() {
      let res = {
        minWidth: `calc( (100% - 630px) / ${this.columns.length - 3} )`,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      };
      this.$emit("widthChange", res);
      return res;
    }
  },
  mounted() {
    this.init();
    this.keyword = this.$route.query.keyword;
  },
  methods: {
    init() {
      if (localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))) {
        this.steps = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
        let nowProductType = this.steps.find(item => {
          if (item.identification) {
            return this.$route.params.identification == item.identification;
          } else {
            return this.$route.params.identification == item.id;
          }
        });
        if (nowProductType) {
          this.productTypeInfo = nowProductType;
          let fatherTarget = this.steps.find(item => item.id == nowProductType.pid);
          this.typeList = this.steps.filter(item => item.pid == fatherTarget.pid);
          this.getProductListFields();
        }
      }
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    getProductListFields() {
      let params1 = {
        req: {
          type_id: this.productTypeInfo.id
        }
      };
      let params2 = {
        req: {
          id: this.productTypeInfo.id
        }
      };
      let promise1 = getProductTpyeListFields(params1);
      let promise2 = getProductInfo(params2);
      Promise.all([promise1, promise2]).then(res => {
        let list = res[0].data.list.filter(item => {
          if (this.filterArr.indexOf(item.varname) > -1) {
            // 国际化处理
            item.title = this.$t("main.varName_" + item.varname);
            return item;
          }
        });
        let expand = res[1].data.wanhui_screen;
        this.expends = expand.map(item => {
          let checked = item.values.map(v => false);
          return {
            ...item,
            checked: checked
          };
        });

        this.liststart = list;
        this.infoColumns = res[1].data.expand;
        this.name = res[1].data.name;
        this.customColumns = res[1].data.expand.filter(value => {
          return value.isCustom === 1;
        });
        this.customColumns.forEach(item => {
          this.$set(this.customForm, item.varname, "");
        });

        this.columns = [{
          varname: "product_model",
          title: this.$t("main.partNumber"),
        }, ...this.expends, ...list.reverse()];
        this.$emit("getColumns", this.columns);
        this.$emit("getExpand", this.expends);
      });
    },
    handleCurrentChange2(val) {
      this.page2 = val;
      this.getProductList(this.tags, this.searchParam);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getProductList(this.tags, this.searchParam);
    },
    handleSubmitCustom() {
      let productInfo = this.customColumns.map(item => {
        return {
          title: item.title,
          value: this.customForm[item.varname]
        };
      });
      let noValueProductIndex = productInfo.findIndex(item => item.value == "");
      let noValueProduct = productInfo.find(item => item.value == "");
      if (noValueProductIndex !== -1) {
        let noValueProductId = 'customInput_' + noValueProductIndex;
        let noValueProductInput = document.getElementById(noValueProductId);
        this.$message({
          message: this.$t('main.fieldIsRequired', { field: noValueProduct.title }),
          type: 'error'
        })
        noValueProductInput.focus();
      } else {
        window.sessionStorage.setItem("settlementInfo", JSON.stringify({
          product_info: productInfo,
          number: this.customForm.num,
          totalNumber: this.customForm.num,
          productimg: this.productImage,
          resource: "custom",
          type_id: this.productTypeInfo.id,
          type_name: this.productTypeInfo.name,
          customForm: this.customForm
        }));
        if (!Cookies.get("userinfo")) {
          this.$router.push({ path: "/login", frompath: "detail" });
        } else {
          this.$router.push({
            path: "/addressInformation"
          });
        }
      }
    },
    customStyles(index) {
      return {
        marginTop: index === 0 ? 0 : "1rem",
        marginLeft: (1.75 * index) + "rem"
      };
    },
    highlightKeywords(content) {
      const keywords = this.keyword && [this.keyword]; // 替换为你的关键词列表
      let highlightedContent = content;
      if (keywords) {
        keywords.forEach(keyword => {
          const regExp = new RegExp(keyword, "gi");
          highlightedContent = highlightedContent.replace(regExp, "<span class=\"highlight\" style=\"color: rgb(255, 0, 13);\">" + keyword + "</span>");
        });
      }
      return highlightedContent;
    },
    gettotal() {
      var total = {};
      total.commonTotal = this.commonTotal;
      total.standardTotal = this.standardTotal;
      return total;
    },
    handleReport() {
      let params = {
        req: {
          ...this.reportInfo,
          content_id: 0,
          site_id: this.$store.state.site_id,
          product_id: this.productTypeInfo.id
        }
      };
      reportApi(params).then(res => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          });
          this.reportInfo = {
            email: "",
            content: ""
          };
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    addGoodToCard(item) {
      let params = {
        req: {
          product_ids: [
            {
              product_id: item.id,
              number: item.num || 1
            }
          ]
        }
      };
      addShopcar(params).then(res => {
        if (res.rsp.code === 0) {
          this.$store.dispatch("setCarNum", true);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    addInquiryToCard(item) {
      let params = {
        req: {
          product_ids: [
            {
              product_id: item.id,
              number: item.num || 1
            }
          ]
        }
      };
      addInquiry(params).then(res => {
        if (res.rsp.code === 0) {
          this.$store.dispatch("setInquiryNum", true);
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          });
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    handleCheckboxChange(e, item, index, title) {
      if (e) {
        let params = {
          req: {
            product_model: item.product_model
          }
        };
        addToCompare(params).then(res => {
          if (res.rsp.code === 0) {
            this.$store.dispatch("setCompareNum", true);
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: "success"
            });
          } else {
            if (title === "commonProductList") {
              this.$set(this.commonProductList[index], "checked", false);
            } else {
              this.$set(this.standardProductList[index], "checked", false);
            }
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        });
      } else {
        let params = {
          req: {
            ids: item.id
          }
        };
        deleteCompare(params).then(res => {
          if (res.rsp.code === 0) {
            this.$store.dispatch("setCompareNum", true);
            this.$message({
              message: this.$t('main.operationCompletedSuccessfully'),
              type: "success"
            });
          } else {
            if (title === "commonProductList") {
              this.$set(this.commonProductList[index], "checked", true);
            } else {
              this.$set(this.standardProductList[index], "checked", true);
            }
            this.$message({
              message: res.rsp.msg,
              type: 'error'
            })
          }
        });
      }
    },
    handleChange(e, item, index, title) {
      if (title === "commonProductList") {
        this.$set(this.commonProductList[index], "num", e);
      } else {
        this.$set(this.standardProductList[index], "num", e);
      }
    },
    getProductList(arr, searchParam) {
      let commonProductObj = [
        {
          condition: "2",
          filed: "product_type",
          expression: "="
        }
      ];
      let standardProductObj = [
        {
          condition: "1",
          filed: "product_type",
          expression: "="
        }
      ];
      let filter = [];
      if (arr && arr.length) {
        filter = arr.map(item => {
          return {
            condition: item.name,
            filed: item.type,
            expression: "="
          };
        });
      }
      let params = {
        req: {
          type_id: this.productTypeInfo.id,
          page: this.page2,
          limit: 10,
          where: searchParam ? [
            ...commonProductObj,
            ...filter,
            {
              condition: "%" + searchParam + "%",
              filed: "name|keywords|description|price|stock|declicks|clicks|comments|iscomment|delivery_has_stock|delivery_no_stock|product_model|product_data",
              expression: "LIKE"
            }
          ] : [
            ...commonProductObj,
            ...filter
          ],
          order: "orderby desc"
        }
      };
      let params2 = {
        req: {
          type_id: this.productTypeInfo.id,
          page: this.page,
          limit: 10,
          where: searchParam ? [
            ...standardProductObj,
            ...filter,
            {
              condition: "%" + searchParam + "%",
              filed: "name|keywords|description|price|stock|declicks|clicks|comments|iscomment|delivery_has_stock|delivery_no_stock|product_model|product_data",
              expression: "LIKE"
            }
          ] : [
            ...standardProductObj,
            ...filter
          ],
          order: "orderby desc"
        }
      };

      let promise1 = getProductTpyeList(params2);
      let promise2 = getProductTpyeList(params);

      Promise.all([promise1, promise2]).then(res => {
        if (res[0].rsp.code === 0) {
          this.standardProductList = res[0].data.list.map(item => {
            item.product_data.map(function(product) {
              item[product.varname] = product.value;
            });
            return {
              ...item,
              num: this.$store.state.carList.pid.indexOf(item.id) > -1 ?
                  this.$store.state.carList.number[this.$store.state.carList.pid.indexOf(item.id)]: 1,
              checked: this.$store.state.compareList.indexOf(item.id) > -1
            };
          });
          this.standardProductList.forEach(v => {
            if (v.type_id === this.productTypeInfo.id && v.product_model === this.$route.query.keyword) {
              this.ExpendIndex.push(v.id);
            }
          });
          this.standardTotal = res[0].data.total;
          if (this.defaultstandardProductNum === -1) {
            this.defaultstandardProductNum = res[0].data.total;
          }

          // 新功能筛选逻辑
          let expand = res[0].data.wanhui_screen;
          this.expends = expand.map(item => {
            let checked = item.values.map(v => {
              let tags = this.tags.filter(value => value.name === v && value.type === item.varname);
              return tags.length > 0;
            });

            return {
              ...item,
              checked: checked
            };
          });
          this.$emit("getExpand", this.expends);
        }

        if (res[1].rsp.code === 0) {
          this.commonProductList = res[1].data.list.map(item => {
            item.product_data.map(function(product) {
              item[product.varname] = product.value;
            });

            return {
              ...item,
              num: this.$store.state.carList.pid.indexOf(item.id) > -1 ?
                  this.$store.state.carList.number[this.$store.state.carList.pid.indexOf(item.id)]: 1,
              checked: this.$store.state.compareList.indexOf(item.id) > -1
            };
          });
          this.commonProductList.forEach(v => {
            if (v.type_id === this.productTypeInfo.id && v.product_model === this.$route.query.keyword) {
              this.ExpendIndex.push(v.id);
            }
          });
          this.commonTotal = res[1].data.total;
          if (this.defaultcommonProductNum === -1) {
            this.defaultcommonProductNum = res[1].data.total;
          }
        }

      });
    },
    handleExpendTable(index) {
      if (!this.ExpendIndex.includes(index)) {
        this.ExpendIndex.push(index);
      } else {
        this.ExpendIndex.forEach((item, i) => {
          if (item === index) {
            this.ExpendIndex.splice(i, 1);
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.i-info {
  .ii-title {
    font-size: 1.875rem;
    font-family: YouSheBiaoTiHei,serif;
    font-weight: 400;
    color: #333333;
    padding: 1.75rem 0 3rem;
  }

  .dz-box {
    background: #fbfbfb;
    padding: 0 1.5rem 0 1.5rem;

    .dz-l {
      width: 55%;
      border-right: 1px solid #d8d9dc;

      /deep/ .el-input__inner {
        border: 0px;
        border-bottom: 1px solid #d8d9dc;
        background-color: #fbfbfb;
      }
    }

    .dz-r {
      width: 45%;
      padding-left: 3rem;
    }
  }

  .fk {
    /deep/ .el-input__inner {
      border: 0px;
      border-bottom: 1px solid #d8d9dc;
    }
  }

  .tjBtn {
    width: 86px;
    height: 32px;
    background: #635796;
    border-radius: 4px;
    color: #fff;
    padding: 0;
  }
}

.i-table {
  margin-bottom: 2rem;
  .td-none {
    width: 100%;
    padding: 50px;
    text-align: center;
    background: #ebebeb;
  }

  .t-th {
    height: 5rem;
    background: #b3b3b3;
  }

  .t-td {
    font-size: 12px;
  }

  .td1 {
    width: 1.25rem;
    min-height: 7.5rem;
    background: #dbdbdb;

    .el-icon-caret-top,.el-icon-caret-bottom {
      width: 1.25rem;
      text-align: center;
    }
    .td1-name {
      text-align: center;
      height: calc(100% - 2.5rem);
      display: grid;
      place-items: center; /* 垂直水平居中 */
      span {
        transform: rotate(270deg);
        position: absolute;
        height: 1.25rem;
      }
    }
  }

  .td-n {
    color:#666666;
    text-align: center;
  }

  .td-i {
    height: 3.75rem;
  }

  .td-r {
    width: calc(100% - 1.25rem);

    .td-td:nth-child(odd) {
      background-color: #ebebeb;
    }

    .td-td:nth-child(even) {
      background-color: #fafafa;
    }

    .td-i:hover {
      background-color: rgba(29, 82, 230, 0.2);
    }

    .hover {
      background-color: rgba(29, 82, 230, 0.2);
    }
  }

  .td2 {
    min-width: 50px;
    text-align: center;
    cursor: pointer;
  }

  .td-n .underline {
    cursor: pointer;
  }

  .td13 {
    min-width: 4.75rem;
    text-align: center;
  }

  .td11 {
    min-width: 100px;
  }

  .td14 {
    min-width: 60px;
  }

  .proBtn {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 10px;
  }

  .td15 {
    min-width: 200px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }


  .th-n {
    text-align: center;
  }

  .p-pages {
    height: 2.25rem;
    background: #dbdbdb;
    border: 1px solid #dbdbdb;
  }

  /deep/ .el-pager li {
    background: white;
    margin: 0.1rem;
  }

  /deep/ .el-pager li.active {
    background: #635796;
    color: white !important;
  }

  /deep/ .el-pager li:hover {
    background: #635796;
    color: white !important;
  }

  /deep/ .el-pagination button:hover, .el-pagination button:focus, .el-pagination button:active {
    color: #635796;
  }

  .mainBtn {
    height: 32px;
    border-radius: 4px;
    padding: 0 3px;
  }

  .addInquiryForGoogle {
    cursor:pointer;
  }

  .addShopCarForGoogle {
    cursor:not-allowed;
  }

  .mainBtnAct {
    cursor:pointer;
  }

  .required {
    color: #F56C6C;
  }
}
@media screen and (max-width: 1400px) {
  .i-table {
    padding: 0 2%;
  }
}
@media screen and (min-width: 1400px) {
  .i-table {
    padding: 0 10%;
  }
}
@media screen and (min-width: 1700px) {
  .i-table {
    padding: 0 15%;
  }
}
</style>
